import FormControlMui, { FormControlProps } from '@mui/material/FormControl';

export function FormControl(props: FormControlProps) {
    return <FormControlMui data-testid={'form-control-container'} {...props} />;
}

export default FormControl;
